import type { ReactNode } from 'react'
import { pushNotice, type NoticeKind } from '@/lib/notices'

type ToastOptions = { icon?: ReactNode; ms?: number }

/**
 * A toast is a chip in the activity bar at the bottom (John, Nov 5 2026: "I
 * don't want any of the floating snack bars. Every snack bar should just be
 * converted into a progress item"): the same call as before puts a notice
 * among the flows, with its own mark or the kind's, for a few seconds. The
 * provider stays so the app's tree reads as it did.
 */
export function ToastProvider({ children }: { children: ReactNode }) {
  return <>{children}</>
}

export function toast(kind: NoticeKind, title: ReactNode, body?: ReactNode, options?: ToastOptions) {
  pushNotice({ kind, title, body, icon: options?.icon, ms: options?.ms ?? (kind === 'error' ? 10_000 : 6_000) })
}

export function useToast() {
  return toast
}
